import { observable, action, computed } from 'mobx'
import api from '../api'
import errorStore from './errorStore'
import translationStore from './translationStore'

class faqStore {
  @observable faqs = []
  @observable loading = true

  constructor() {
    this.fetchFaqs()
  }

  @computed get categories() {
    return [...new Set(this.faqs.map(faq => faq.category))]
  }

  @action.bound fetchFaqs() {
    return api.FAQ.getAll()
      .then(action(faqs => this.faqs = faqs))
      .catch(action(err => {
        this.errors = err.response && err.response.body && err.response.body.errors
        errorStore.displayError(translationStore.translate('fetch_faq_error'))
      }))
      .finally(action('FAQ fetch completed' ,() => { this.loading = false }))
  }
}

export default new faqStore()



// WEBPACK FOOTER //
// ./src/stores/faqStore.js